import { render } from "./createUser.vue?vue&type=template&id=2c937f99&scoped=true"
import script from "./createUser.vue?vue&type=script&lang=js"
export * from "./createUser.vue?vue&type=script&lang=js"

import "./createUser.vue?vue&type=style&index=0&id=2c937f99&scoped=true&lang=css"

import exportComponent from "/home/quantum/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c937f99"]])

export default __exports__